import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { navSections, siteName } from "@/mocks/mangaData";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkMap: Record<string, string> = {
    topic: "/topic",
    community: "/community",
    rank: "/rank",
    booklist: "/booklist",
    about: "/about",
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 shadow-sm backdrop-blur border-b border-background-200"
          : "bg-background-50"
      }`}
    >
      <nav className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <Link
          to="/"
          className="flex items-center gap-2.5"
          onClick={() => setOpen(false)}
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-open-line text-lg"></i>
          </span>
          <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
            {siteName}
            <span className="ml-2 hidden text-xs font-normal text-foreground-500 sm:inline">
              同好交流聚集地
            </span>
          </span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navSections.map((s) => (
            <NavLink
              key={s.key}
              to={linkMap[s.key]}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  isActive && s.key !== "topic"
                    ? "bg-primary-100 text-primary-800 font-medium"
                    : "text-foreground-700 hover:bg-background-200"
                }`
              }
            >
              {s.name}
            </NavLink>
          ))}
          <Link
            to="/topic"
            className="ml-2 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            加入讨论
          </Link>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-200 md:hidden"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 md:hidden">
          <div className="flex flex-col gap-1 pt-3">
            {navSections.map((s) => (
              <NavLink
                key={s.key}
                to={linkMap[s.key]}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-200"
              >
                {s.name}
              </NavLink>
            ))}
            <Link
              to="/topic"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-full bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50"
            >
              加入讨论
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}